import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var PlateDataQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query GetPlateVehicle($plate: String = \"\") {\n    plateVehicle(plate: $plate) {\n      brandName\n      modelName\n      year\n      versionName\n      plate\n    }\n  }\n"])));
export default PlateDataQuery;